const MassBoomerangInitialValues = {
  barCode: '',
};

export default MassBoomerangInitialValues;

export type MassBoomerangSearchBody = typeof MassBoomerangInitialValues;
